import PageTitle from "../../../components/PageTitle";
import Button from "../../../components/Button";
import { useNavigate, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { httprequest } from "../../../data/api";
import Table from "../../../components/Table/Table";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react/dist/iconify.js";
import Badge from "../../../components/Badge";
// import useStyles from "../styles";
import { TableSearch } from "../../../components/Table/TableActions";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import Modal from "../../../components/Modal";
import PopModal from "../../../components/PopupModal/PopModal";
import useWindowSize from "../../../hooks/useWindow";

// const CLASSES_ENDPOINT = "/api/v1/class";
const ALL_ENROLMENT_EXAM_CONFIGS = "/api/v1/enrolment-exam-configs";

const AdminEnrolmentExam = () => {
  const navigate = useNavigate();
  // const classes = useStyles();
  const [searchResult, setSearchResult] = useState([]);
  // const [classesData, setClassData] = useState([]);
  const [filterStatus, setFilterStatus] = useState("");
  const [isPageFetching, setIsPageFetching] = useState(false);
  const [allEnrolmentData, setAllEnrollmentData] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [currentSelected, setCurrentSelected] = useState({});
  const [preserveQuestionsInBank, setPreserveQuestionsInBank] = useState(false);

  const handleDeleteModal = (row) => {
    setCurrentSelected(row);
    setPreserveQuestionsInBank(false);
    setDeleteModal(!deleteModal);
  };

  const width = useWindowSize();
  const mobile = width < 600;
  const preserveCheckboxStatus = String(currentSelected?.status ?? "").trim().toLowerCase();
  const shouldShowPreserveQuestionsCheckbox = preserveCheckboxStatus !== "" && preserveCheckboxStatus !== "empty";

  /**
   * Function to close the delete modal.
   * This function sets the delete modal state to false, effectively closing it.
   */
  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
    setPreserveQuestionsInBank(false);
  };

  /**
   * Function to fetch all enrolment exams.
   * This function makes an API call to retrieve all enrolment exams and updates the state with the fetched data.
   */
  const getAllEnrolmentExam = () => {
    setIsPageFetching(true);
    httprequest.get(ALL_ENROLMENT_EXAM_CONFIGS).then((res) => {
      setIsPageFetching(false);
      setAllEnrollmentData(res?.data?.data);
      setSearchResult(res?.data?.data);
    }).catch((err) => {
      setIsPageFetching(false);
      toast.error(err?.response?.data);
    });
  };

  /**
   *  Function to handle the deletion of an enrolment exam.
   *  This function makes an API call to delete the selected enrolment exam and updates the state accordingly.
   */
  const handleDeleteAnExam = () => {
    setIsDeleting(true);
    httprequest.delete(`${ALL_ENROLMENT_EXAM_CONFIGS}/${currentSelected?.id}`, {
      data: {
        preserve_questions_in_bank: !!preserveQuestionsInBank
      }
    }).then(() => {
      setIsDeleting(false);
      toast.success("Exam Deleted Succesfully");
      getAllEnrolmentExam();
      handleCloseDeleteModal();
    }).catch((err) => {
      setIsDeleting(false);
      toast.error(err?.response?.data?.message);
    });
  };

  /**
   * Function to handle filter changes.
   * @param {*} e - The event object from the select input.
    * This function updates the filter status and filters the enrolment data based on the selected status.
  */
  const handleFilterChange = (e) => {
    const { value } = e.target;
    setFilterStatus(value);

    // Filter assignments based on selected status
    const filteredByStatus = value === "published"
      ? allEnrolmentData?.filter((data) => data?.status === "published")
      : value === "draft"
        ? allEnrolmentData?.filter((data) => data?.status === "draft")
        : value === "withdrawn"
          ? allEnrolmentData?.filter((data) => data?.status === "withdrawn")
          : allEnrolmentData;
    setSearchResult(filteredByStatus);
  };

  /**
  * Function to handle search functionality for enrolment exams.
  * This function filters the enrolment exams based on the search input.
  * @param {*} e - The event object from the search input.
  */
  const handleSearchEnrolmentExam = (e) => {
    const { value } = e.target;
    const valArray = value.split(" ");

    const filteredByStatus = filterStatus
      ? allEnrolmentData.filter((data) => data.status.toLowerCase() === filterStatus.toLowerCase())
      : allEnrolmentData;

    // Filter by partial match in subject, class, and creator's name
    const result = filteredByStatus?.filter((data) => valArray?.every(
      (word) => data?.subject?.name?.toLowerCase().includes(word.toLowerCase()) ||
                  data?.class?.name?.toLowerCase().includes(word.toLowerCase()) ||
                  data?.created_by?.name?.toLowerCase().includes(word.toLowerCase())
    ));

    setSearchResult(result);
  };

  useEffect(() => {
    getAllEnrolmentExam();
  }, []);

  const columns = [
    {
      name: "Subject",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Subject</p>}
          {row?.subject || "--/--"}
        </>
      )
    },
    {
      name: "Classes",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Classes</p>}
          {row?.class_id?.id ? (
            <span className="class_div" key={row.class_id.id}>
              {row?.class_id?.name}
            </span>
          ) : (
            row?.classes?.map((clss) => (
              <span className="class_div" key={clss?.id}>
                {clss?.name}
              </span>
            )) || "--/--"
          )}
        </>
      )
    },
    {
      name: "Duration (in mins)",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Duration (in mins)</p>}
          {row?.duration || "--/--"}
        </>
      )
    },
    {
      name: "Title",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Title</p>}
          {row?.title || "--/--"}
        </>
      )
    },
    {
      name: "Date Updated",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Date Updated</p>}
          {row?.updated_at ? row.updated_at.substring(0, 10) : "--/--"}
        </>
      )
    },
    {
      name: "Status",
      center: "true",
      cell: (row) => <Badge status={row.status} />
    },
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <Link to={`/enrolments/enrolment-examination-details/${row?.id}`}>
            <button className="table-action-icon">
              <Icon icon="fluent:eye-16-regular" />
            </button>
          </Link>
          <button
            className="table-action-icon"
            onClick={() => navigate(`/enrolments/enrolment-examination-details/${row?.id}?editConfig`)}
          >
            <Icon icon="heroicons:pencil-square-solid" />
          </button>
          <button className="table-action-icon delete-icon" onClick={() => handleDeleteModal(row)}>
            <Icon icon="mingcute:delete-2-line" />
          </button>
        </div>
      )
    }
  ];

  return (
    <>
      <PageTitle
        title="Enrolment Examination"
        subtitle="see all the enrollexamination papers"
        button={
          <div className="flex gap-10">
            <PopModal title="Enrolment Examination" videoUrl="https://youtu.be/SEwkQ530-80" />
            <Button onClick={() => navigate("/enrolments/create-enrolment-examination")} variant="primary" buttonSize="fluid" color="btndefault" buttonName="Create Enrolment Examination" />
          </div>
        }
      />
      <div className="page-content">
        <Table data={searchResult} columns={columns} subHeader={true} pagination subHeaderComponent={
          searchResult?.length > 0 && (
            <div className="action_div">
              <TableSearch placeholder="Search here..." searchTableFunc={handleSearchEnrolmentExam} />
              <div className="text-center gap-10 cursor-pointer">
                {isPageFetching ? <Icon icon="svg-spinners:270-ring-with-bg" width="20" height="20" style={{ color: "#858585" }} />
                  : <Icon onClick={getAllEnrolmentExam} icon="hugeicons:reload" width="20" height="20" style={{ color: "#858585" }} />}
                <div>
                  <SelectGroup
                    children={
                      <select name="type" onChange={handleFilterChange}>
                        <option value="">-- Sort By--</option>
                        <option value="published">Published</option>
                        <option value="draft">Draft</option>
                        <option value="withdrawn">Withdrawn</option>
                      </select>
                    }
                  />
                </div>
              </div>
            </div>
          )}
        />
        <Modal
          title="Delete Enrolment Examination"
          subtitle={
            <div>Are you sure you want to delete
              <span className="modal-name-highlight">{" "}
                {currentSelected?.subject ?? "this subject"} for{" "}
                {currentSelected?.classes?.map((clss, index) => (
                  <span className="" key={clss?.id}>
                    {clss?.name}
                    {index < currentSelected.classes.length - 1 ? ", " : ""}
                  </span>
                )) || " these classes"}.
              </span>{" "}
             Implication is that this Examination will be deleted completely
            </div>}
          modalContent={shouldShowPreserveQuestionsCheckbox ? (
            <div style={{ marginTop: 8 }}>
              <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
                <input
                  type="checkbox"
                  checked={preserveQuestionsInBank}
                  onChange={(e) => setPreserveQuestionsInBank(e.target.checked)}
                />
                Preserve questions on this Examination and add them to bank.
              </label>
            </div>
          ) : <></>}
          modalFooter={
            <>
              <Button variant="danger" buttonName="Delete Examination" buttonSize="full" color="btndefault" onClick={handleDeleteAnExam} isLoading={isDeleting} />
            </>
          }
          isopen={deleteModal}
          closeModal={handleCloseDeleteModal}
        />
      </div>
    </>
  );
};

export default AdminEnrolmentExam;
